'use client';

import { useEffect } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { processPendingRecordings } from '@/lib/db';

export default function AppInitializer({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Registra il Service Worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').then(registration => {
          console.log('Service Worker registrato con successo:', registration);
        }).catch(error => {
          console.log('Registrazione del Service Worker fallita:', error);
        });
      });
    }

    // Processa le registrazioni in sospeso all'avvio dell'app
    processPendingRecordings().then(count => {
        if (count > 0) {
            toast.success(`${count} registrazione/i in sospeso sono state recuperate e salvate.`);
            // Invia un evento per aggiornare la cronologia se è aperta
            window.dispatchEvent(new Event('storage'));
        }
    }).catch(error => {
        console.error("Errore durante il recupero delle registrazioni:", error);
        toast.error("Si è verificato un errore durante il recupero delle registrazioni.");
    });
  }, []);

  return (
    <>
      <Toaster />
      {children}
    </>
  );
}

